import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, BiddingReducer, BiddingState } from './bidding-reducer';


const BiddingContext = createContext<BiddingState | undefined>(undefined);
const QuestionAnwserContextDispatchContext = createContext({} as any);

const BiddingProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(BiddingReducer, {} as BiddingState);

    return (
        <BiddingContext.Provider value={state}>
            <QuestionAnwserContextDispatchContext.Provider value={dispatch}>
                {children}
            </QuestionAnwserContextDispatchContext.Provider>
        </BiddingContext.Provider>
    );
}

const useBiddingState = () => {
    const context = useContext(BiddingContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useBiddingDispatch = () => {
    const context = useContext(QuestionAnwserContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { BiddingProvider, useBiddingState, useBiddingDispatch, ACTION_TYPES };

